import { VHCRecordLabourInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateBreakLabourInput = {
  logId: number;
  itemId: number;
  labourId: number;
  requestBody?: VHCRecordLabourInput;
};

export const useUpdateBreakLabourMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsBrakesLabours, UpdateBreakLabourInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, labourId, requestBody }: UpdateBreakLabourInput) =>
      VhcRecordLogService.putVhcRecordsItemsBrakesLabours(logId, itemId, labourId, requestBody),
    options
  );
